module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/trainbg.73502c40.jpg";